<template>
  <v-container>
    <v-card>
      <v-card-text>
        <div style="position: relative; padding-top: 56.25%;">
          <iframe
            src="https://iframe.videodelivery.net/be0c7287de9476adfb32cf5eb0206db5?poster=https%3A%2F%2Fvideodelivery.net%2Fbe0c7287de9476adfb32cf5eb0206db5%2Fthumbnails%2Fthumbnail.jpg%3Ftime%3D%26height%3D600"
            style="border: none; position: absolute; top: 0; left: 0; height: 100%; width: 100%;"
            allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;"
            allowfullscreen="true"
          ></iframe>
        </div>
        <hr class="my-4" />
        <v-row class="my-4">
          <v-btn color="primary" class="mx-auto" @click="openCal" x-large>
            Book a 15 minute discussion
          </v-btn>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>
<script>
export default {
  methods: {
    openCal: function() {
      // eslint-disable-next-line
      Calendly.initPopupWidget({
        url: "https://calendly.com/kevin-1176/15min",
      });
      return false;
    },
  },
};
</script>
